import cx from "classnames";

import errorImages from "common/constants/errorImages";
import Image from "common/components/Image";

import Button, { ButtonProps } from "../buttons/Button";

import styles from "../../styles/ErrorContainer.module.less";

export type ErrorContainerProps = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  image?: string;
  imageAlt?: string;
  actions?: { label: string; onClick: () => void; variant?: ButtonProps["variant"] }[];
  size?: "auto-fill" | "m";
};

const ErrorContainer = ({
  image = errorImages.ErrorDefault,
  imageAlt = "Error",
  title = "Uh oh!",
  description = "Something went wrong.",
  actions = [],
  size = "m",
}: ErrorContainerProps) => (
  <div className={cx(styles.container, styles[`size-${size}`])}>
    <Image className={styles.image} src={image} alt={imageAlt} />
    <h1 className={styles.title}>{title}</h1>
    <div className={styles.description}>{description}</div>
    {!!actions.length && (
      <div className={styles.actions}>
        {actions.map(({ label, onClick, variant = "primary" }) => (
          <Button key={label} onClick={onClick} variant={variant}>
            {label}
          </Button>
        ))}
      </div>
    )}
  </div>
);

export default ErrorContainer;
